import script from "./BindStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./BindStudent.vue?vue&type=script&setup=true&lang=js"

import "./BindStudent.vue?vue&type=style&index=0&id=5ad8cb04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad8cb04"]])

export default __exports__